
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lon/mining/trade/share",
      function () {
        return require("private-next-pages/lon/mining/trade/share.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lon/mining/trade/share"])
      });
    }
  